module.exports = __webpack_public_path__ + "static/media/AvantGardeBook.dbc3b6f0.svg";